import { render, staticRenderFns } from "./r-main-panel.vue?vue&type=template&id=22a90e2b"
import script from "./r-main-panel.vue?vue&type=script&lang=js"
export * from "./r-main-panel.vue?vue&type=script&lang=js"
import style0 from "./r-main-panel.vue?vue&type=style&index=0&id=22a90e2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports